import { Box, Title } from '@mantine/core';
import { ApiKeyForm } from '../components/ApiKeyForm';

export const AddApiKey = () => (
  <Box>
    <Title order={3} mb={12}>
      Add new API key
    </Title>
    <ApiKeyForm apiKey={null} />
  </Box>
);
